import { mainApi } from "services/main";
import {
  GetGaiaObjectRequest,
  GetGaiaObjectResponse,
  DeleteGaiaObjectRequest,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getGaiaObject: builder.query<GetGaiaObjectResponse, GetGaiaObjectRequest>({
      query: (request: GetGaiaObjectRequest) => {
        const { category, teamName, gaiaObjectId } = request;
        const hasQueryParams = category || teamName;

        const base = `gaia-objects/${gaiaObjectId}`;
        const params: Record<string, string> = {};
        if (category) params.category = category;
        if (teamName) params.teamName = teamName;

        return hasQueryParams ? { url: base, params } : { url: base };
      },
    }),
    deleteGaiaObject: builder.mutation<void, DeleteGaiaObjectRequest>({
      query: (request: DeleteGaiaObjectRequest) => {
        return {
          url: `gaia-objects/${request.gaiaObjectId}/soft-delete`,
          body: request,
          method: "PUT",
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetGaiaObjectQuery, useDeleteGaiaObjectMutation } =
  extendedApi;
